import moment from 'moment'
import { AddApplicantAvailabilityFormData } from '../types/applicantAvailability'

const getApplicationNameFromId = (
  applicationNameIdPairs: any[] | undefined,
  id: string
): string => {
  if (applicationNameIdPairs && applicationNameIdPairs.length > 0) {
    return applicationNameIdPairs.find((application) => application.id === id)
      ?.name
  } else {
    return ''
  }
}
const futureAvailabiliy = (el: AddApplicantAvailabilityFormData) => {
  return moment().hour(0).minutes(0).isBefore(el.startTime)
}
export { getApplicationNameFromId, futureAvailabiliy }
